import Repository from "./masterRepository";
const GET_NOTIFICATION = "get";
const EDIT_NOTIFICATION = "edit";

export default {
  getAllNotification(payload) {
    return Repository.post(transformRoute(GET_NOTIFICATION), payload);
    },
    editNotification(payload) {
    return Repository.post(transformRoute(EDIT_NOTIFICATION), payload);
  },
  
};
const transformRoute = (route) => {
  return `/adminNotification/${route}`;
};
